export default __webpack_public_path__ + "static/media/img-soon-bg.9fe64915.svg";